import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative px-4 pt-8 pb-12 md:pt-16 md:pb-20 max-w-3xl mx-auto text-center" data-id="element-79">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-80">
        {/* Opening Lead */}
        <div className="mb-8 space-y-4 text-gray-400 italic text-lg leading-relaxed max-w-xl mx-auto" data-id="element-81">
          <p data-id="element-82">Hay un tipo de cansancio que no se arregla con "motivación".</p>
          <p data-id="element-83">
            Es el cansancio de abrir el celular, ver 30 ideas para hacer dinero,
            guardar 10 videos… y terminar el día igual: con la misma presión y
            la misma cuenta esperando.
          </p>
          <p className="text-white font-medium not-italic" data-id="element-84">
            Si hoy tú estás en modo "necesito algo que funcione ya", esto es
            para ti.
          </p>
        </div>

        {/* Main Headline */}
        <h1 className="font-display font-bold text-5xl md:text-7xl uppercase leading-[0.9] tracking-tight mb-6 text-white" data-id="element-85">
          Tu Primer <span className="text-brand-yellow" data-id="element-86">Ingreso Extra</span> en
          7 Días
        </h1>

        <p className="font-display text-2xl md:text-3xl text-gray-300 uppercase tracking-wide mb-8" data-id="element-87">
          (Sin Experiencia • Sin Seguidores)
        </p>

        {/* Product Image */}
        <div className="relative mb-10 group" data-id="element-88">
          <div className="absolute inset-0 bg-brand-yellow/20 blur-3xl rounded-full opacity-30 group-hover:opacity-50 transition-opacity duration-500" data-id="element-89" />
          <img src="https://cdn.magicpatterns.com/uploads/4SAY6ffbdAx9U8pPdsF6X3/heylloyd-image-1770495589615.png" alt="Tablet mostrando el PDF Tu Primer Ingreso Extra en 7 Días" className="relative z-10 mx-auto w-full max-w-md drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-90" />
        </div>

        {/* Subheadline/Promise */}
        <p className="text-xl md:text-2xl text-gray-200 mb-8 font-medium max-w-2xl mx-auto" data-id="element-91">
          El sistema simple para conseguir tu primer cliente o venta en tu
          tiempo libre. <br data-id="element-92" />
          <span className="text-brand-yellow" data-id="element-93">
            Una sola ruta. Un solo plan. 7 días.
          </span>
        </p>

        {/* CTA Button */}
        <button onClick={scrollToPricing} className="bg-brand-yellow hover:bg-brand-yellowHover text-black font-display font-bold text-2xl uppercase py-4 px-8 rounded-lg shadow-[0_0_20px_rgba(234,179,8,0.4)] hover:shadow-[0_0_30px_rgba(234,179,8,0.6)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 mx-auto w-full md:w-auto" data-id="element-94">
          Descargar el Plan de 7 Días
          <ArrowRight className="w-6 h-6" strokeWidth={3} data-id="element-95" />
        </button>

        <p className="mt-4 text-sm text-gray-500" data-id="element-96">
          Acceso inmediato • PDF Digital • Pago único $27
        </p>
      </motion.div>
    </section>;
}